export default [
    {
        "id": "products",
        "html": require('./products/html').default,
        "js": require('./products/js').default,
        "minJs": require('./products/minJs').default,
        "pages": 'ProductList'
    }
]